import { RecordPageRenderContext } from "../../../../types";
import {
  RecordSectionHeader,
  RecordSectionTitle,
} from "../../../../utils/styled";
import { SectionInfoIconWithTooltip } from "../../../common/Tooltip";
import { SCHEMA_TITLES } from "../../constants";
import {
  getTitleFromKey,
  getSectionTooltipInfo,
} from "../../helpers";
import { resolveCustomStyle } from "../../style-config";
import { renderField } from "./recordPage.field";

function buildSectionTitle(
  sectionKey: string,
  ctx: RecordPageRenderContext,
): JSX.Element {
  return (
    <RecordSectionTitle
      $customStyle={resolveCustomStyle({
        applicability: "section-title",
        selectedSetup: ctx.selected.setup.value,
        sectionKey,
        isRecordOpen: ctx.isRecordOpen,
      })}
    >
      {getTitleFromKey(sectionKey, ctx.t, ctx.language)}
    </RecordSectionTitle>
  );
}

function renderDefaultHeader(
  sectionKey: string,
  ctx: RecordPageRenderContext,
): JSX.Element {
  return (
    <RecordSectionHeader>
      {buildSectionTitle(sectionKey, ctx)}
      <SectionInfoIconWithTooltip
        customStyle={resolveCustomStyle({
          applicability: "section-info-button",
          selectedSetup: ctx.selected.setup.value,
          sectionKey,
          isRecordOpen: ctx.isRecordOpen,
        })}
        tooltip={getSectionTooltipInfo({
          selectedTabSectionKey: ctx.selectedTabSectionKey,
          selectedDashboardTabSectionKey: ctx.selectedDashboardTabSectionKey,
          sectionKey,
          schema: ctx.schema,
        })}
      />
    </RecordSectionHeader>
  );
}

function renderInventoryBuildingsHeader(
  sectionKey: string,
  ctx: RecordPageRenderContext,
): JSX.Element {
  switch (sectionKey) {
    case "building_details":
      return (
        <RecordSectionHeader $customStyle="inventory-building-header">
          {buildSectionTitle(sectionKey, ctx)}
          {renderField("is_enabled", ctx)}
        </RecordSectionHeader>
      );

    // case "another_section":
    //   return ( ... );

    default:
      return renderDefaultHeader(sectionKey, ctx);
  }
}

export function renderSectionHeader({
  sectionKey,
  ctx,
}: {
  sectionKey: string;
  ctx: RecordPageRenderContext;
}): JSX.Element {
  switch (ctx.schema.title) {
    case SCHEMA_TITLES.INVENTORY_BUILDINGS:
      return renderInventoryBuildingsHeader(sectionKey, ctx);

    // Future setups go here:
    // case SCHEMA_TITLES.SOME_OTHER_SETUP:
    //   return renderSomeOtherSetupHeader(sectionKey, ctx);

    default:
      return renderDefaultHeader(sectionKey, ctx);
  }
}
